import { render, staticRenderFns } from "./header1.vue?vue&type=template&id=fb9cd808&scoped=true"
import script from "./header1.vue?vue&type=script&lang=js"
export * from "./header1.vue?vue&type=script&lang=js"
import style0 from "./header1.vue?vue&type=style&index=0&id=fb9cd808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9cd808",
  null
  
)

export default component.exports